import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
export const ModalSignatureContainer = styled(Box)(({ theme }) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    padding: '10px',

    '& .form-separate-label': {
        fontWeight: '500',
        lineHeight: '1.8',
        color: theme.palette.text.primary,
    },
}));

export const SignatureInfo = styled('div')(({ theme }) => ({
    display: 'flex',

    '& .helper': {
        flexGrow: 2,
    },

    '& .MuiButton-root': {
        marginLeft: 'auto',
        textTransform: 'none',
        fontWeight: 500,
        fontSize: theme.typography.pxToRem(14),
        color: theme.palette.text.secondary,
        textDecoration: 'underline',
    },
}));